import * as React from "react";
function SvgPolaroid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M36.1 21.8c2.6 0 4.7-2 4.8-4.6 0-2.6-2.2-4.8-4.8-4.8-2.6 0-4.8 2.2-4.8 4.8.1 2.6 2.3 4.6 4.8 4.6zm0-6.8c1.3 0 2.3 1 2.4 2.2 0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4.1-1.2 1.2-2.2 2.4-2.2zM48 8.4c0-2-1.6-3.6-3.6-3.6H3.6C1.6 4.8 0 6.4 0 8.4v31.2c0 2 1.6 3.6 3.6 3.6h40.8c2 0 3.6-1.6 3.6-3.6V8.4zM3.7 7.2h40.8c.6.1 1.1.6 1.1 1.3v25.7l-9.8-7.6-8.6 8-13.2-16L2.4 32.9V8.5c0-.7.6-1.3 1.3-1.3zM2.4 39.4v-2.6l11.6-14 14.8 18.1H3.7c-.7-.2-1.3-.8-1.3-1.5zm42.2 1.4H31.9l-3.2-4.1 7.2-6.8 9.7 7.3v2.2c.1.6-.4 1.3-1 1.4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPolaroid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
